import $ from "jquery";

$(document).on("click", '[data-js="jsLinkBack"]', function (e) {
  const { href } = e.target;
  if (document.referrer.includes(`${href}?`) && window.history.length > 1) {
    e.preventDefault();
    window.history.back();
  }
});
